module.exports = __webpack_public_path__ + "assets/media/day3.5c335c20.mp3";